module.exports = __webpack_public_path__ + "img/21_DSC8024.cd575627.jpg";